'use client';

import React from 'react';
import PropTypes from 'prop-types';
import {
    AdvancedMarker,
    useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';
import MapMarker from '../Shared/MapMarker';

ClinicMapMarker.propTypes = {
    data: PropTypes.object.isRequired,
    onMarkerSelect: PropTypes.func.isRequired,
};

export default function ClinicMapMarker({ data, onMarkerSelect }) {
    const [markerRef, marker] = useAdvancedMarkerRef();

    const mapIcon = (
        <MapMarker type={data.flagship ? 'flagship' : 'pharmacy'} />
    );

    return (
        <>
            <AdvancedMarker
                ref={markerRef}
                onClick={() => onMarkerSelect(marker, data)}
                title={data.title}
                position={{
                    lat: data.lat,
                    lng: data.lng,
                }}
                zIndex={data.flagship ? 2 : 1}
            >
                {mapIcon}
            </AdvancedMarker>
        </>
    );
}
